import Login from "../Pages/Auth/Login";
import OAuthRedirect from "../Pages/Auth/OAuthRedirect";
import ShippingCalculator from "../Pages/ShippingCalculator/ShippingCalculator";

const UnAuthorisedRoutes = [
    {
        title: 'Login',
        path: 'login',
        element: <Login />
    },
    {
        title: 'Shipping Calculator',
        path: 'shipping-calculator',
        element: <ShippingCalculator />
    },
    {
        path: '/oauth-callback',
        element: <OAuthRedirect />
    },
];

export default UnAuthorisedRoutes;